export default __webpack_public_path__ + "static/media/team-perks-icon.6f68def5.svg";